export const ROUTES = {
  LOGIN: {
    path: 'login',
    fullPath: '/login',
  },
  DASHBOARD: {
    path: 'dashboard',
    fullPath: '/dashboard',
  },
  EMPLOYEE_MANAGEMENT: {
    path: 'employee-management',
    fullPath: '/employee-management',
  },
  ADDITIONAL_EMAILS: {
    path: 'additional-emails',
    fullPath: '/additional-emails',
  },
  ROLE_MANAGEMENT: {
    path: 'roles-management',
    fullPath: '/roles-management',
  },
  TASK_MANAGEMENT: {
    path: 'tasks-management',
    fullPath: '/tasks-management',
  },
  DEPARTMENT_MANAGEMENT: {
    path: 'department-management',
    fullPath: '/department-management',
  },
  DESIGNATION_MANAGEMENT: {
    path: 'designation-management',
    fullPath: '/designation-management',
  },
  BRAND_MANAGEMENT: {
    path: 'brand-management',
    fullPath: '/brand-management',
  },
} as const;
